import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { ErrorBoundary } from './components/ErrorBoundary';
import { RealtimeMonitor } from './components/RealtimeMonitor';
import { RealtimeAlertsPanel } from './components/RealtimeAlertsPanel';
import { AlertToastBridge } from './components/AlertToastBridge';
import { Home } from './pages/Home';
import { Token } from './pages/Token';
import { Portfolio } from './pages/Portfolio';
import { SafeLink } from './pages/SafeLink';
import { Alerts } from './pages/Alerts';
import { Whales } from './pages/Whales';
import { ApiDocs } from './pages/ApiDocs';


export default function App() {
  return (
    <div className="app">
      <Header />
      <RealtimeMonitor />
      <AlertToastBridge />
      <main className="main">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/whales" element={<Whales />} />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route path="/safe/:address" element={<SafeLink />} />
            <Route path="/:address" element={<Token />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <RealtimeAlertsPanel />
    </div>
  );
}
